import { createAction } from '@mews/framework/redux';
import { getLanguageCode } from '../../modules/app/selectors';
import {
    FETCH_PAYMENT_CONFIGURATION_FAILED,
    FETCH_PAYMENT_CONFIGURATION_STARTED,
    FETCH_PAYMENT_CONFIGURATION_SUCCEEDED,
} from '../../modules/paymentConfigurations/actionTypes';
import { getSelectedHotelId } from '../../modules/resourceOrder/selectors';
import { DistributorPromiseThunkAction } from '../../types';

export function fetchPaymentConfiguration(): DistributorPromiseThunkAction {
    return async (dispatch, getState, { apiService }) => {
        const state = getState();
        const enterpriseId = getSelectedHotelId(state);
        const languageCode = getLanguageCode(state);

        dispatch(createAction(FETCH_PAYMENT_CONFIGURATION_STARTED, { enterpriseId }));
        return apiService
            .getPaymentConfiguration({ enterpriseId, languageCode })
            .then(({ paymentGateway, surchargeConfiguration }) => {
                dispatch(
                    createAction(FETCH_PAYMENT_CONFIGURATION_SUCCEEDED, {
                        paymentGateway,
                        surchargeConfiguration,
                        enterpriseId,
                    })
                );
                return surchargeConfiguration;
            })
            .catch((error) => {
                dispatch(createAction(FETCH_PAYMENT_CONFIGURATION_FAILED, { error, enterpriseId }));
                throw error;
            });
    };
}
